<template>
<div class="form">
  <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline;">HK3 - AKTIVITI PERIKANAN</h1>

    <v-text-field
      outlined 
      dense
      rounded
      v-model="HID"
      label="HID"
      width="20px"
      disabled
    ></v-text-field>


      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-spacer></v-spacer>
                <v-btn
                color="error"
                small
                @click="dialogPengesahan=true;"
                >
                  Padam
                </v-btn>
            </v-card-title>
            
            <v-data-table
              :headers="headers"
              :items="dataHK3"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            >
            <template v-slot:item.HK3A1= "{ item }">
            {{ formatNumber(item.HK3A1) }}
            </template>
            <template v-slot:item.HK3A2= "{ item }">
            {{ formatNumber(item.HK3A2) }}
            </template>
            <template v-slot:item.HK3A3= "{ item }">
            {{ formatNumber(item.HK3A3) }}
            </template>
            <template v-slot:item.HK3A4= "{ item }">
            {{ formatNumber(item.HK3A4) }}
            </template>
            <template v-slot:item.HK3B= "{ item }">
            {{ formatNumber(item.HK3B) }}
            </template>
            <template v-slot:item.HK3C1= "{ item }">
            {{ formatNumber(item.HK3C1) }}
            </template>
            <template v-slot:item.HK3C2= "{ item }">
            {{ formatNumber(item.HK3C2) }}
            </template>
            <template v-slot:item.HK3C3= "{ item }">
            {{ formatNumber(item.HK3C3) }}
            </template>
            <template v-slot:item.HK3C4= "{ item }">
            {{ formatNumber(item.HK3C4) }}
            </template>
            <template v-slot:item.HK3INCS21a= "{ item }">
            {{ formatNumber(item.HK3INCS21a) }}
            </template>
            <template v-slot:item.HK3INCS21A_i= "{ item }">
            {{ formatNumber(item.HK3INCS21A_i) }}
            </template>
            <template v-slot:item.HK3INCS21A_ii= "{ item }">
            {{ formatNumber(item.HK3INCS21A_ii) }}
            </template>
            <template v-slot:item.HK3INCS21A_iii= "{ item }">
            {{ formatNumber(item.HK3INCS21A_iii) }}
            </template>
          </v-data-table>
      </v-card>   
    </v-card> 


<v-card>
  <v-card-title>
    Pendapatan daripada bekerja sendiri (perikanan)
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <!-- s24 -->
      <v-row v-show="showS24">
        <v-col>
        S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
        <v-autocomplete
            :items="masco"
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="PK"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s25 -->
      <v-row v-show="showS25">
        <v-col>
        S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
        <v-autocomplete
            :items="msic"
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="PN"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s26 -->
      <v-row>
        <v-col>
        S26 : Nyatakan tempoh bagi soalan S24 <strong>[M]</strong>
          <v-row>
            <!-- datepicker mula -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="dateMula"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateMula"
                    label="Mula"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateMula"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(dateMula)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- datepicker tamat -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="dateTamat"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTamat"
                    label="Tamat"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTamat"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(dateTamat);kiraTempoh()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- tempoh Sebenar -->
            <!-- <v-col cols="1">
              <v-text-field
                  v-model="Msebenar"
                  label="Tempoh Sebenar(bulan)"
                  outlined
                  disabled
                  dense
              ></v-text-field>
            </v-col> -->

            <!-- tempoh -->
            <v-col cols="3">
              <v-autocomplete
                  min="0"
                  maxlength="2"
                  :items="tambahlookupbulan"
                  v-model="M"
                  label="Tempoh(bulan)"
                  outlined
                  dense
                  :item-text="item => item.id"
                  item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      

<v-form ref="form2" :disabled="disabledInput"> <!-- disable input kalau month NaN/empty -->
      <!-- s38 -->
      <!-- <v-row>
        <v-col cols="4">
        S38 : Mempunyai akaun penyata kira-kira?
        <v-select
             :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="HK3S38"
        ></v-select>
        </v-col>
      </v-row>
       -->
      <!-- s39 -->
      <!-- <div v-show="soalanAkaunPenyataYa"> -->
      <!-- <v-row>
        <v-col>
          S39 : Tempoh penyata kira-kira (dalam bulan)
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK3S39"
                      label="bulan"
                      outlined
                      type="number"
                      dense
                ></v-text-field>
              </v-col>

          </v-row>
        </v-col>
      </v-row> -->

      <!-- s40 -->
      <!-- <v-row v-show="showS40">
        <v-col>
          S40 : Keuntungan bersih sebagaimana tercatat dalam penyata kira-kira dalam 12 bulan yang lalu
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK3B1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row> -->

      <!-- s41 -->
      <!-- <v-row v-show="showS41">
        <v-col>
          S41 : Anggaran keuntungan bersih berdasarkan penyata kira-kira tahun sebelum ini dalam 12 bulan yang lalu
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK3B2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      </div> -->

      <!-- * Sekiranya jawapan di S38 adalah Tidak, maka S50 - S54 perlu pengisian -->
      <!-- s50,s51 -->
    <div >
      <v-row>
        Tiada Akaun Penyata kira-kira<br>
        A.Butir - butir pengeluaran
        <v-row class="mt-2">
          <!-- s50 -->
          <v-col>
            S50 : Nilai jumlah jualan atau pengeluaran (termasuk ikan kolam/sangkar, air tawar dan air paya/laut) dalam 12 bulan yang lalu <strong>[A1]</strong>
            <v-text-field
                  v-model="HK3A1"
                  label="RM"
                  outlined
                  type="number"
                  dense
                  persistent-hint
                  hint="Setahun"
                  @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          <!-- s51 -->
          <v-col>
            S51 : Pendapatan yang diterima daripada sewaan bot/perkakas dalam 12 bulan yang lalu <strong>[A2]</strong>
            <br><br>
            <v-text-field
                  v-model="HK3A2"
                  label="RM"
                  outlined
                  type="number"
                  dense
                  persistent-hint
                  hint="Setahun"
                  @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>
      </v-row>
      
      <!-- s52,s53 -->
      <v-row>
        <!-- s52 -->
        <v-col>
          S52 : Lain-lain <strong>[A3]</strong>
          <v-text-field
                v-model="HK3A3"
                label="RM"
                outlined
                type="number"
                dense
                persistent-hint
                hint="Setahun"
                @keypress="limitDigits"
                :rules="schemeRule.no8digit" 
          ></v-text-field>
        </v-col>

        <!-- s53 -->
        <v-col>
          S53 : Jumlah Pengeluaran <strong>[A4]</strong>
          <v-text-field
                v-model="HK3A4"
                label="RM"
                outlined
                type="number"
                dense
                persistent-hint
                hint="Setahun"
                @keypress="limitDigits"
                :rules="schemeRule.no8digit" 
                disabled
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- s54 -->
      <v-row>
        <!-- s54 -->
        <v-col>
          B. Perbelanjaan (Termasuk Pembayaran Dalam Bentuk Mata Benda)<br>
          S54 : Jumlah perbelanjaan <strong>[B]</strong>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>Termasuk anak ikan; makanan; kapur; garam; air batu; peti ikan/bakul; bahan pembakar dan minyak pelincir; 
              bayaran air; pembayaran untuk upah buruh/awak-awak; sewaan tanah/kolam; sewaan bot/perkakas yang dibayar; pembaikan 
              dan penyelenggaraan kolam/bot/perkakas dan jentera; pembayaran jeti; makanan semasa penangkapan ikan di laut; komisen; 
              bayaran pemasaran tangkapan dan perbelanjaan lain
            </span>
          </v-tooltip>
          <v-text-field
                v-model="HK3B"
                label="RM"
                outlined
                type="number"
                dense
                persistent-hint
                hint="Setahun"
                style ="width:360px"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

      <!-- s55 -->
      <v-row>
        <v-col>
          S55 : Pendapatan bersih <strong>[C1]</strong>
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK3C1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      persistent-hint
                      hint="Setahun"
                      disabled
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s56,57 -->
      <v-row>
        <v-col>
          S56 : Peratus pembahagian yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
          <v-row>
              <v-col cols="2" sm="6" md="4">
                <v-text-field
                      v-model="HK3C2"
                      label="%"
                      outlined
                      type="number"
                      dense
                      :rules="[rules.percentage,rules.takmauPoint]"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row> 

      <!-- s57,s58,s59 -->
      <v-row>
        <!-- s57 -->
        <v-col>
          S57 : Nilai mutlak bagi C2 <strong>[C3]</strong>
          <br><br>
          <v-row>
              <v-col>
                <v-text-field
                      v-model="HK3C3"
                      outlined
                      label="RM"
                      type="number"
                      dense
                      persistent-hint
                      hint="setahun"
                      @keypress="limitDigits"
                      :rules="schemeRule.no8digit"

                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
        
        <!-- s58 -->
        <v-col>
          S58 : Anggaran barangan keluaran yang digunakan sendiri dalam 12 bulan yang lalu <strong>[C4]</strong>
          <v-row>
              <v-col>
                <v-text-field
                      v-model="HK3C4"
                      outlined
                      label="RM"
                      type="number"
                      dense
                      persistent-hint
                      hint="setahun"
                      @keypress="limitDigits"
                      :rules="schemeRule.no8digit"
                      @change="kiraINCS01()"
                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>

        <!-- s59 -->
        <v-col>
          S59 : Pendapatan bersih yang diterima oleh ahli isi rumah <strong>[C5]</strong>
          <v-row>
              <v-col>
                <v-text-field
                      v-model="HK321A"
                      outlined
                      label="RM"
                      type="number"
                      dense
                      persistent-hint
                      hint="setahun"
                      @keypress="limitDigits"
                      :rules="schemeRule.no8digit"

                ></v-text-field>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <!-- s60-->
      <v-row>
        <v-col >
          S60 : Pendapatan daripada C5:
          <br><br>
          <v-row  class="mt-2">
            <v-col cols="4" sm="4" md="4">
              i) Pendapatan berkaitan pertanian dan penternakan dalam talian melalui transaksi e-dagang (cth: menerima pesanan melalui tiktok shop, facebook, lazada, shopee, laman web khusus, dll) <strong>[21A(i)]</strong>
              <br><br>
              <!-- <v-text-field
                    v-model="HK321A_i"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
            </v-col>
            <v-col cols="4" sm="4" md="4"><br><br><br><br>
              <v-text-field
                    v-model="HK3INCS21A_i"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"

              ></v-text-field>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="4" sm="4" md="4">
              ii) Pendapatan berkaitan pertanian dan penternakan dalam talian melalui transaksi bukan e-dagang (cth: menerima pesanan melalui whatsapp, emel, dll) <strong>[21A(ii)]</strong>
              <br><br>
              <!-- <v-text-field
                    v-model="HK321A_ii"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
            </v-col>

            <v-col cols="4" sm="4" md="4"><br><br><br><br>
              <v-text-field
                    v-model="HK3INCS21A_ii"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"

              ></v-text-field>
              </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="4" md="4">
              iii) Pendapatan berkaitan pertanian dan penternakan bukan dalam talian <strong>[21A(iii)]</strong>
              <br><br>
              <!-- <v-text-field
                    v-model="HK321A_iii"
                    outlined
                    type="number"
                    dense
                    readonly
                    hint="%"
                    persistent-hint
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
            </v-col>
            <v-col cols="4" sm="4" md="4"><br><br><br>
              <v-text-field
                    v-model="HK3INCS21A_iii"
                    label="RM"
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"

              ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>   

      <!-- s37 -->
      <v-row>
        <v-col cols="6">
        S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="KL"
        ></v-select>
        </v-col>
      </v-row>

</v-form>
</v-form>
  </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        :disabled="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK3()"
    >
      Kemaskini
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('1')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<!-- <v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog> -->

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("1")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>


<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>


</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////


export default {
    //props:['data'],
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

        this.getData();//dapatkan data based on HID

    },

    data: () => ({
        showS24 : true,
        showS25 : true,
        butangSimpan: true,
        butangKemaskini: false,
        // disabledInput:true,
        // soalanAkaunPenyataYa : false,
        // soalanAkaunPenyataTidak : false,
        // showS40: false,
        // showS41: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        dialogPengesahan: false,
        successMessage:'',
        errMessage:'',
        kemaskiniDialog: false,
        message: "Saving Data",
        popUpALert:false,
        search: '',
        masco:[],
        msic:[],
        yaTidak:[],
        selectedData: [],

        /////////////////////data declaration//////////////////////////
        
        PK:'',
        PN:'',
        // menu1:'',
        // dateMula:'',
        // menu2:'',
        // dateTamat:'',
        // HK3S38:'',
        // HK3S39:'',
        // HK3B1:0,
        // HK3B2:0,
        HK3A1:0,
        HK3A2:0,
        HK3A3:0,
        HK3M: 0,
        //HK3A4:0,
        HK3B:0,
        HK3C1:0,
        HK3C2:0,
        HK3C3:0,
        HK3C4:0,
        HK321A:0,
        HK321A_i:0,
        HK321A_ii:0,
        HK321A_iii:0,
        HK3INCS21A_i: 0,
        HK3INCS21A_ii: 0,
        HK3INCS21A_iii: 0,
        KL:'',

        HID: '',
        KAW: '',
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:'',
        dataHK3: [],
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'NOAIR', value: 'NOAIR' },
          { text: 'PK', value: 'PK' },
          { text: 'PN', value: 'PN' },
          { text: 'M', value: 'HK3M' },
          // { text: 'HK3B1', value: 'HK3B1' },
          // { text: 'HK3B2', value: 'HK3B2' },
          { text: 'A1', value: 'HK3A1' },
          { text: 'A2', value: 'HK3A2' },
          { text: 'A3', value: 'HK3A3' },
          { text: 'A4', value: 'HK3A4' },
          { text: 'B', value: 'HK3B' },
          { text: 'C1', value: 'HK3C1' },
          { text: 'C2', value: 'HK3C2' },
          { text: 'C3', value: 'HK3C3' },
          { text: 'C4', value: 'HK3C4' },
          { text: 'C5', value: 'HK3INCS21a' },
          { text: 'INCS 21a(i)', value: 'HK3INCS21A_i' },
          { text: 'INCS 21a(ii)', value: 'HK3INCS21A_ii' },
          { text: 'INCS 21a(iii)', value: 'HK3INCS21A_iii' },
         // { text: 'INCS 21a', value: 'HK3INCS21a' },
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
          {
          text: 'HK3',
          disabled: true,
          href: 'hk3',
        },
       
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
        required: v => !!v || 'field is required',
        emel: (value) => {
          return /.+@.+\..+/.test(value) || 'E-mail must be valid'
        },
        percentage:(value)=>{
          return (value <= 100) || 'Percentage must between 1 - 100'
        },
        takmauPoint:(value)=>{
          return (value % 1 === 0)? true:'No point needed'
        }
          
        },
      select: null,
      checkbox: false,
    }),

    methods: {
      formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
        return value.replace(/,/g, '');
      },
      getUnits: function(a) {
            alert(`${a}`)
      },
      validate () {
        this.$refs.form.validate()
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async simpan (){
      
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)

            try {

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK3`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                P: this.Ps,
                PK:  this.PK.kod,
                PN:  this.PN.kod,
                M:  this.M,
                // HK3S38:  this.HK3S38.id,
                // HK3S39 : this.HK3S39,
                // HK3B1 : this.HK3B1,
                // HK3B2 : this.HK3B2,
                HK3A1 : this.HK3A1,
                HK3A2 : this.HK3A2,
                HK3A3 : this.HK3A3,
                HK3A4 : this.HK3A4,
                HK3B : this.HK3B,
                HK3C1 : this.HK3C1,
                HK3C2 : this.HK3C2,
                HK3C3 : this.HK3C3,
                HK3C4 : this.HK3C4,
                HK3INCS21a : this.HK321A,
                HK321A_i : this.HK321A_i,
                HK321A_ii : this.HK321A_ii,
                HK321A_iii : this.HK321A_iii,
                HK3INCS21A_i : this.HK3INCS21A_i,
                HK3INCS21A_ii : this.HK3INCS21A_ii,
                HK3INCS21A_iii : this.HK3INCS21A_iii,
                KL : this.KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK3INCS21a : this.totalHK3INCS21a,
                totalHK3INCS21A_i : this.totalHK3INCS21A_i,
                totalHK3INCS21A_ii : this.totalHK3INCS21A_ii,
                totalHK3INCS21A_iii : this.totalHK3INCS21A_iii,

              })
                this.res = res.data;
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = true;
                this.reset();
                //this.simpankeHK3();
                //this.message = "Data Saved";
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.successMessage = 'Data Disimpan!';
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error; 
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';

        }
      },
      async updateHK3(){
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK3`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                P: this.Ps,
                PK: this.PK,
                PN:  this.PN,
                M:  this.M,
                // HK3S38:  this.HK3S38.id,
                // HK3S39 : this.HK3S39,
                // HK3B1 : this.HK3B1,
                // HK3B2 : this.HK3B2,
                HK3A1 : this.HK3A1,
                HK3A2 : this.HK3A2,
                HK3A3 : this.HK3A3,
                HK3A4 : this.HK3A4,
                HK3B : this.HK3B,
                HK3C1 : this.HK3C1,
                HK3C2 : this.HK3C2,
                HK3C3 : this.HK3C3,
                HK3C4 : this.HK3C4,
                HK3INCS21a : this.HK321A,
                HK321A_i : this.HK321A_i,
                HK321A_ii : this.HK321A_ii,
                HK321A_iii : this.HK321A_iii,
                HK3INCS21A_i : this.HK3INCS21A_i,
                HK3INCS21A_ii : this.HK3INCS21A_ii,
                HK3INCS21A_iii : this.HK3INCS21A_iii,
                KL : this.KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK3INCS21a : this.totalHK3INCS21a,
                totalHK3INCS21A_i : this.totalHK3INCS21A_i,
                totalHK3INCS21A_ii : this.totalHK3INCS21A_ii,
                totalHK3INCS21A_iii : this.totalHK3INCS21A_iii,

              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = false;               
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }  
      },
      
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK3"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK1 based on HID
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK3?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataHK3 = dataz;
            console.log(this.dataHK3)

          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
          this.selectedData = [];
          this.selectedData = row;
          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.showS24 = false;
          this.showS25 = false;
          this.butangSimpan = false;
          this.butangKemaskini = true;
          

          this.HID = row.HID;
          this.NOAIR = row.NOAIR;
          this.PK = row.PK;
          this.PN = row.PN;
          this.HK3M = row.HK3M;
          // this.HK3S38 = row.HK3S38;
          // this.HK3S39 = row.HK3S39;
          // this.HK3B1 = row.HK3B1;
          // this.HK3B2 = row.HK3B2;
          this.HK3A1 = this.stripCommas(row.HK3A1);
          this.HK3A2 = this.stripCommas(row.HK3A2);
          this.HK3A3 = this.stripCommas(row.HK3A3);
          this.HK3A4 = this.stripCommas(row.HK3A4);
          this.HK3B = this.stripCommas(row.HK3B);
          this.HK3C1 = this.stripCommas(row.HK3C1);
          this.HK3C2 = this.stripCommas(row.HK3C2);
          this.HK3C3 = this.stripCommas(row.HK3C3);
          this.HK3C4 = this.stripCommas(row.HK3C4);
          this.HK321A = this.stripCommas(row.HK3INCS21a);
          this.HK3INCS21A_i = this.stripCommas(row.HK3INCS21A_i);
          this.HK3INCS21A_ii = this.stripCommas(row.HK3INCS21A_ii);
          this.HK3INCS21A_iii = this.stripCommas(row.HK3INCS21A_iii);



          //this.KL = row.KL;
          if(row.KL == 1){
            this.KL = this.yaTidak[0];
          }
          if(row.KL == 2){
            this.KL = this.yaTidak[1];
          }


          // or just do something with your current clicked row item data
          //console.log(row)
      },
      goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
      
          if(this.KL.id == "1"){
            this.$router.push({name: "JRB"});
          }
          if(this.KL.id == "2"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
         
        }   
      },
      kiraHK3A4() {
      var total = 0;
      total =
        Number(this.HK3A1) +
        Number(this.HK3A2) +
        Number(this.HK3A3) 
      this.HK3A4 = total;
    },
      
    },
    watch:{
      // HK3S39(){
        
      //   if(this.HK3S39 >=6){
      //     this.showS40 = true;
      //     this.showS41 = false;
      //   }else{
      //     this.showS40 = false;
      //     this.showS41 = true;
      //   }
      // },
      // HK3B1(){
      //   this.HK3C1 = this.HK3B1;
      // },
      // HK3B2(){
      //   this.HK3C1 = this.HK3B2;
      // },
      HK3A3(){
        this.HK3A4 = Number(this.HK3A1) + Number(this.HK3A2) + Number(this.HK3A3);
      },
      HK3B(){
        this.HK3C1 = Number(this.HK3A4) - Number(this.HK3B);
      },
      HK3C2(){
        //this.HK3C3 = Number(this.HK3C1) * Number(this.HK3C2);
        this.HK3C3 = (Number(this.HK3C2) / 100) * Number(this.HK3C1);

      },
      HK3C4(){
        this.HK321A = Number(this.HK3C3) + Number(this.HK3C4);
      },
      HK321A_i(){ 
        this.HK3INCS21A_i = Number(this.HK321A_i) * Number(this.HK321A)/100;
      },
      HK321A_ii(){
        this.HK3INCS21A_ii = Number(this.HK321A_ii) * Number(this.HK321A)/100;
        
        this.HK321A_iii = Number(this.HK321A_i) + Number(this.HK321A_ii);
        this.HK321A_iii = 100 - Number(this.HK321A_iii);
      },
      HK321A_iii(){
        this.HK3INCS21A_iii = Number(this.HK321A_iii) * Number(this.HK321A)/100;
      },
      INCS11B(){
        if(this.M == 0){
          this.INCS11 = Number(this.INCS11B)
        }
        else{
          this.INCS11 = Number(this.INCS11B)*Number(this.M);
        }
        this.kiraINCS01();
        
      },
      INCS12B(){
        if(this.M == 0){
          this.INCS12 = Number(this.INCS12B)
        }
        else{
          this.INCS12 = Number(this.INCS12B)*Number(this.M);
        }
        this.kiraINCS01();
        
      },
      INCS13B(){
        if(this.M == 0){
          this.INCS13 = Number(this.INCS13B)
        }
        else{
          this.INCS13 = Number(this.INCS13B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS14B(){
        if(this.M == 0){
          this.INCS14 = Number(this.INCS14B)
        }
        else{
          this.INCS14 = Number(this.INCS14B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS15B(){
        if(this.M == 0){
          this.INCS15 = Number(this.INCS15B)
        }
        else{
          this.INCS15 = Number(this.INCS15B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS16B(){
        if(this.M == 0){
          this.INCS16 = Number(this.INCS16B)
        }
        else{
          this.INCS16 = Number(this.INCS16B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS17B(){
        if(this.M == 0){
          this.INCS17 = Number(this.INCS17B)
        }
        else{
          this.INCS17 = Number(this.INCS17B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS18B(){
        if(this.M == 0){
          this.INCS18 = Number(this.INCS18B)
        }
        else{
          this.INCS18 = Number(this.INCS18B)*Number(this.M);
        }
        this.kiraINCS01();
      },
      INCS19aB(){
        if(this.M == 0){
          this.INCS19a = Number(this.INCS19aB)
        }
        else{
          this.INCS19a = Number(this.INCS19aB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19bB(){
        if(this.M == 0){
          this.INCS19b = Number(this.INCS19bB)
        }
        else{
          this.INCS19b = Number(this.INCS19bB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19cB(){
        if(this.M == 0){
          this.INCS19c = Number(this.INCS19cB)
        }
        else{
          this.INCS19c = Number(this.INCS19cB)*Number(this.M);
        }
        this.kiraINCS19();
      },
      INCS19(){
        this.kiraINCS01();
      },
      M(val){
    
        if(isNaN(val)){
            this.disabledInput = true;
          }else{
            this.disabledInput = false;
        }
      },
      HK3INCS21A_i(val){
        if(isNaN(val)){
            this.butangSimpan = true;
          }else{
            this.butangSimpan = false;
        }
      },
    },
    computed:{
      // M: function(){
          
      //     var d1 = new Date(this.dateMula);
      //     var d2 = new Date(this.dateTamat);
          
      //     var months;
      //     months = (d2.getFullYear() - d1.getFullYear()) * 12;
      //     months -= d1.getMonth();
      //     months += d2.getMonth()+1;
          
      //     if(months > 12){
      //       return 12
      //     }else{
      //       return months
      //     }
      // },
      Msebenar: function(){
          var d1 = new Date(this.dateMula);
          var d2 = new Date(this.dateTamat);
          
          var months = 0;
          months = (d2.getFullYear() - d1.getFullYear()) * 12;
          months -= d1.getMonth();
          months += d2.getMonth()+1;

          return months;
      },
      tambahlookupbulan() {
      return lookup.getBulan();
      },
      totalHK3INCS21a:  function(){
          var total = 0;
            ///calculate semua value HK3INCS21a yang telah di insert
            if(this.dataHK3.length >= 1){
              for(var i = 0; i < this.dataHK3.length ; i++){
                total = total + Number(this.dataHK3[i].HK3INCS21a)
              }
            }
          ///tambahkan total yang telah diinsert dengan current HK3INCS21a yang bakal diinsert
          //total = total + Number(this.HK321A) - Number(this.selectedData.HK321A);
          if(this.selectedData.HK321A){
              total = total + Number(this.HK321A) - Number(this.selectedData.HK321A);
          }else{
              total = total + Number(this.HK321A) ;
          } 
          return total;
      }, 
       totalHK3INCS21A_i:  function(){

          var total = 0;
          if(this.dataHK3.length >= 1){
            ///calculate semua value HK3INCS21A_i yang telah di insert
            for(var i = 0; i < this.dataHK3.length ; i++){
              total = total + Number(this.dataHK3[i].HK3INCS21A_i)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK3INCS21A_i yang bakal diinsert
          //total = total + Number(this.HK3INCS21A_i) - Number(this.selectedData.HK3INCS21A_i);
          if(this.selectedData.HK3INCS21A_i){
              total = total + Number(this.HK3INCS21A_i) - Number(this.selectedData.HK3INCS21A_i);
          }else{
              total = total + Number(this.HK3INCS21A_i) ;
          }
          return total;

      }, 
      totalHK3INCS21A_ii:  function(){

          var total = 0;
          if(this.dataHK3.length >= 1){
            ///calculate semua value HK3INCS21A_ii yang telah di insert
            for(var i = 0; i < this.dataHK3.length ; i++){
              total = total + Number(this.dataHK3[i].HK3INCS21A_ii)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK3INCS21A_ii yang bakal diinsert
          //total = total + Number(this.HK3INCS21A_ii) - Number(this.selectedData.HK3INCS21A_ii);
          if(this.selectedData.HK3INCS21A_ii){
              total = total + Number(this.HK3INCS21A_ii) - Number(this.selectedData.HK3INCS21A_ii);
          }else{
              total = total + Number(this.HK3INCS21A_ii) ;
          }
          return total

      }, 
      totalHK3INCS21A_iii:  function(){

         var total = 0;
         if(this.dataHK3.length >= 1){
          ///calculate semua value HK3INCS21A_iii yang telah di insert
          for(var i = 0; i < this.dataHK3.length ; i++){
            total = total + Number(this.dataHK3[i].HK3INCS21A_iii)
          }
         }
          ///tambahkan total yang telah diinsert dengan current HK3INCS21A_iii yang bakal diinsert
          //total = total + Number(this.HK3INCS21A_iii) - Number(this.selectedData.HK3INCS21A_iii);
          if(this.selectedData.HK3INCS21A_iii){
              total = total + Number(this.HK3INCS21A_iii) - Number(this.selectedData.HK3INCS21A_iii);
          }else{
              total = total + Number(this.HK3INCS21A_iii) ;
          }
          return total
      },
      HK3A4: function () {
      var total = 0;
      total =
        Number(this.HK3A1) +
        Number(this.HK3A2) +
        Number(this.HK3A3) 
      return total;
    },
    schemeRule() {
      return schemeRule;
    },

    }
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>